import { computed } from 'vue';
import { BoardLayout } from '@superthread-com/api';
import { useStore } from 'vuex';
import constants from '@/utilities/constants';

export default function useCalendarLayoutFeature() {
  const store = useStore();

  const calendarLayoutFeatureAvailable = computed(() => {
    return store.getters.getTeamFeatureEnabled(constants.featureFlagIds.calendarLayout);
  });

  const allowSwitchingToCalendarLayout = (layoutId: string) => {
    if (!calendarLayoutFeatureAvailable.value && layoutId === BoardLayout.Calendar) {
      store.dispatch('setShowUpgradePlanPopup', constants.featureFlagIds.calendarLayout);
      return false;
    }
    return true;
  };

  const showCalendarUpgradeBadge = (id: string) => {
    return id === BoardLayout.Calendar && !calendarLayoutFeatureAvailable.value;
  };

  return {
    calendarLayoutFeatureAvailable,
    allowSwitchingToCalendarLayout,
    showCalendarUpgradeBadge,
  };
}
